export default statesRun

/** @ngInject */
function statesRun(featuresService, $rootScope) {
    return $rootScope.$on('$stateChangeSuccess', (ev, to, toParams, from, fromParams) => {
        $rootScope.previousState = from.name
        $rootScope.currentState = to.name
    })
}



// WEBPACK FOOTER //
// ./src/config/states.js